<!-- <div class="d-flex justify-content-center align-items-center gap-2">
    <button class="btn eod-btn-primary btn-sm" (click)="onUserAction('subscribe')">
        Subscribe 
    </button>

    <button class="btn eod-btn-danger btn-sm" (click)="onUserAction('endTrial')">
       End Trial
    </button>
</div> -->

<ds-button [buttonInput]="buttonConfig1" (onClick)="onUserAction(action1)"></ds-button>
<ds-button [buttonInput]="buttonConfig2" (onClick)="onUserAction(action2)"></ds-button>